import {defineField, defineType} from 'sanity'
import {GoPerson} from 'react-icons/go'

export default defineType({
  name: 'blog.author',
  title: 'Author',
  type: 'document',
  icon: GoPerson,
  groups: [{name: 'content', default: true}, {name: 'metadata'}],
  fields: [
    defineField({
      name: 'name',
      type: 'string',
      group: 'content',
      validation: (rule) => rule.required(),
    }),
    defineField({
      name: 'image',
      type: 'image',
      options: {
        hotspot: true,
      },
      group: 'content',
    }),
    defineField({
      name: 'bio',
      type: 'portableText',
      group: 'content',
    }),
    defineField({
      name: 'metadata',
      type: 'metadata',
      group: 'metadata',
    }),
  ],
  preview: {
    select: {
      title: 'name',
      media: 'image',
    },
  },
})
